const LoginStyles = {
    baseStyle: {
        modal: {
            heading: {
                align: 'center',
                fontSize: '30px',
                fontWeight: '400',
                color: 'black.100'
            },
            divider: {
                borderColor: 'black.100',
                borderWidth: '1px'
            },
            descriptionBox: {
                display: 'inline-flex',
                gap: '10px',
                margin: '25px 0'
            },
            descriptionText: {
                color: 'black.100',
                fontSize: '17px',
                letterSpacing: '0.085px',
                lineHeight: '26px',
                fontWeight: '300'
            },
            alertBox: {
                backgroundColor: 'red.30',
                marginBottom: '-10px',
                borderRadius: '3px'
            },
            alertText: {
                color: 'red.400',
                fontSize: '16px',
                fontWeight: '300'
            },
            link: {
                textDecoration: 'underline',
                textUnderlineOffset: '4px',
                color: 'black.300',
                letterSpacing: '0.08px',
                lineHeight: '25px',
                fontSize: '16px',
                fontWeight: '300',
                _hover: {color: 'black.300'}
            },
            button: {
                borderRadius: '90px',
                padding: '15px 50px',
                width: '190px',
                fontSize: '17px',
                fontFamily: 'body',
                margin: 'auto',
                height: '56px',
                lineHeight: '26px',
                fontWeight: '400',
                backgroundColor: 'black.300',
                _hover: {
                    backgroundColor: 'black.50'
                },
                color: 'white'
            },
            crossImage: {
                width: '15px',
                height: '15px',
                cursor: 'pointer'
            },
            body: {
                padding: '30px',
                paddingInlineStart: 0,
                paddingInlineEnd: 0,
                borderRadius: {base: '20px 20px 0 0', md: '20px'}
            }
        }
    }
}

export default LoginStyles
